import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const navItems = [
  { path: '/', label: 'Panel de Control', icon: 'ri-dashboard-line' },
  { path: '/clientes', label: 'Clientes', icon: 'ri-user-line' },
  { path: '/pacientes', label: 'Pacientes', icon: 'ri-bear-smile-line' },
  { path: '/historia-clinica', label: 'Historia Clínica', icon: 'ri-heart-pulse-line' },
  { path: '/agenda', label: 'Agenda', icon: 'ri-calendar-line' },
  { path: '/sala-de-espera', label: 'Sala de Espera', icon: 'ri-time-line' },
  { path: '/productos', label: 'Productos', icon: 'ri-shopping-bag-line' },
  { path: '/proveedores', label: 'Proveedores', icon: 'ri-truck-line' },
  { path: '/ventas', label: 'Ventas', icon: 'ri-shopping-cart-line' },
  { path: '/caja', label: 'Caja', icon: 'ri-cash-line' },
  { path: '/finanzas', label: 'Finanzas', icon: 'ri-bank-line' },
  { path: '/recordatorios', label: 'Recordatorios', icon: 'ri-notification-3-line' },
  { path: '/reportes', label: 'Reportes', icon: 'ri-bar-chart-line' },
  { path: '/auditoria', label: 'Auditoría', icon: 'ri-shield-check-line' },
  { path: '/configuracion', label: 'Configuración', icon: 'ri-settings-3-line' },
];

export default function Sidebar() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useAuth();

  return (
    <aside
      className={`flex flex-col bg-[#0F5132] text-white transition-all duration-300 ${collapsed ? 'w-16' : 'w-60'}`}
    >
      <div className="flex items-center h-14 px-4 border-b border-white/10">
        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
          <i className="ri-plant-line text-xl"></i>
        </div>
        {!collapsed && (
          <span className="ml-3 font-semibold text-sm tracking-wide whitespace-nowrap">
            NEOZOO
          </span>
        )}
      </div>

      <div className="flex-1 overflow-y-auto py-2">
        {[...navItems.filter((item) => !['/configuracion', '/proveedores'].includes(item.path) || user?.role === 'admin'), ...(user?.role === 'admin' ? [{ path: '/usuarios', label: 'Usuarios', icon: 'ri-team-line' }] : [])].map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center mx-2 px-3 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap ${
                isActive
                  ? 'bg-white/15 text-white'
                  : 'text-white/70 hover:bg-white/10 hover:text-white'
              }`}
              title={collapsed ? item.label : undefined}
            >
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className={item.icon}></i>
              </div>
              {!collapsed && <span className="ml-3">{item.label}</span>}
            </Link>
          );
        })}
      </div>

      <div className="p-2 border-t border-white/10">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="flex items-center mx-2 px-3 py-2.5 rounded-lg text-sm text-white/70 hover:bg-white/10 hover:text-white transition-colors w-full"
        >
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className={collapsed ? 'ri-arrow-right-s-line' : 'ri-arrow-left-s-line'}></i>
          </div>
          {!collapsed && <span className="ml-3">Contraer</span>}
        </button>
      </div>
    </aside>
  );
}
